export function CalculateScrollbarOffset<TElement extends HTMLElement>(element: TElement | null | undefined): number {
	return (element?.offsetWidth ?? 0) - (element?.clientWidth ?? 0);
}
